import routes from 'routes';

export const getGeographyLocationLandingPageUrl = (landingPage, geographyLocationName) => routes.landingPageWithLocation.replace('/:landingPage', landingPage.url).replace(':locationText', geographyLocationName);
